

module Sxc.Site {
    export class Helpers {
        private roomlist;

        constructor(roomlist) {
            this.roomlist=roomlist;
        }

        /**************************************************************************/

        _callGet(url : string, data : {[key : string] : any}) {
            return this._sendAjax(url, data, "GET");
        }

        _callPost(url : string, data : {[key : string] : any},complete=null) {
            return this._sendAjax(url, data, "POST",complete);
        }

        _sendAjax(url : string, data : {[key : string] : any}, method : "GET"|"POST" = "GET",complete=null) {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: url,
                    type: method,
                    data: data,
                    crossDomain: true,
                    dataType: "text",
                    xhrFields: { withCredentials: true },
                    complete:complete==null?function () {}:complete,
                    success: (response : string) => {
                        try {
                            resolve( $.parseJSON(response) );
                        } catch (e) {
                            reject("Failed to parse JSON from calling '" + e);
                        }
                    },
                    error: (...args : any[]) => {
                        console.error("WebAPI2", "Failed to call WebAPI2", ...args);

                        reject();
                    }
                });
            });
        }

        /**
         * Random integer
         */
        GetRand(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
        }

        isiOS() {
            return [
                    'iPad Simulator',
                    'iPhone Simulator',
                    'iPod Simulator',
                    'iPad',
                    'iPhone',
                    'iPod'
                ].includes(navigator.platform)
                // iPad on iOS 13 detection
                || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        }

        getTranslate(keyName : string) {
            if(keyName in this.roomlist.babesHandler.translateJSON) {
                return this.roomlist.babesHandler.translateJSON[keyName];
            }

            return '%%' + keyName + '%%';
        }


        /*Logging függvény*/
        log(msg=""){
            if(this.roomlist.consoleLogging){console.log(msg);}
        }

        async gdprFirstCreditShowpopup()  {
            return new Promise((resolve, reject) => {
                this._callGet('/ajax/credit/getcredits', {
                    "topups": "1"//,"reg_date":"1"
                }).then((responseJSON: CreditResponse) => {
                    if (responseJSON.result == 'success') {
                        if (responseJSON.topups === 0) {
                            window["chatClient"].app.view.topupPanel.needFirstCredit = true;
                            window["chatClient"].app.view.topupPanel.show(true);
                            resolve(true);
                        }
                    }
                    resolve(false);
                });
            });
        }

        _openShare(){
            $("#popup_share").removeClass("hidden");
            $("#popup_share #share-text").text(window.location.href);
            $("#share-title").text($(".sxcc-user-data h1").text());

            $("#share-qr-code").html("");
            // @ts-ignore
            new QRCode(document.getElementById("share-qr-code"), {
                text: window.location.href, width: 220, height: 220/*, colorDark : "#5868bf", colorLight : "#ffffff",
                // @ts-ignore
                correctLevel : QRCode.CorrectLevel.H*/
            });
        }

        escapeHtml(text) {
            var map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };

            return text.replace(/[&<>"']/g, function(m) { return map[m]; });
        }

        getCurrentRoomidFromChat(){
            let currentroomid= null
            try{currentroomid=window["chatClient"].app.roomHistory[window["chatClient"].app.roomHistory.length-1];}
            catch (e) { }
            return currentroomid;
        }
    }
}